import { css } from "@emotion/react";

import { Icon, IconDisplay, IconSize } from "src/components/Icon";
import { colorCssVars } from "src/theme/color";
import { horizontalStackCss } from "src/theme/spacing";
import { FontWeight } from "src/theme/text";

export function ProTipBadge() {
  return (
    <div css={[horizontalStackCss.xs, { alignItems: "center" }]}>
      <Icon
        iconImport={() => import("src/components/Icon/icons/RocketIcon")}
        size={IconSize.MEDIUM}
        display={IconDisplay.ACCENT}
      />
      <span
        css={css`
          font-weight: ${FontWeight.MEDIUM};
          color: var(${colorCssVars.text.secondary});
        `}
      >
        Tip
      </span>
    </div>
  );
}
